import React from "react";
import CloseBtn from "../CloseBtn";
import { Alert, Button, Col, Form, Modal, Row } from "react-bootstrap";
import { Controller } from "react-hook-form";
import Select from "react-select";


const EditUserModal = ({
  show,
  onHide,
  isEdit,
  onSubmit,
  control,
  errors,
  roleOptions,
  rolesLoading,
}) => {
  return (
    <Modal show={show} onHide={onHide} size="md" centered>
      <Modal.Header>
        <Modal.Title>{isEdit ? "Edit User" : "Add New User"}</Modal.Title>
      </Modal.Header>
      <CloseBtn onClick={onHide} color="#bf352b" />
      <Form onSubmit={onSubmit} autoComplete="off">
        <Modal.Body>
          <Controller
            name="name"
            control={control}
            rules={{ required: "Name is required" }}
            render={({ field }) => (
              <Form.Group className="mb-3" controlId="name">
                <Form.Label>Name*</Form.Label>
                <Form.Control {...field} isInvalid={!!errors.name} />
                <Form.Control.Feedback type="invalid">
                  {errors.name?.message}
                </Form.Control.Feedback>
              </Form.Group>
            )}
          />

          <Controller
            name="email"
            control={control}
            rules={{
              required: "Email is required",
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: "Invalid email address",
              },
            }}
            render={({ field }) => (
              <Form.Group className="mb-3" controlId="email">
                <Form.Label>Email*</Form.Label>
                <Form.Control
                  {...field}
                  autoComplete="off"
                  inputMode="email"
                  isInvalid={!!errors.email}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.email?.message}
                </Form.Control.Feedback>
              </Form.Group>
            )}
          />

          <Controller
            name="mobileNumber"
            control={control}
            rules={{
              required: "Mobile number is required",
              pattern: {
                value: /^[0-9]{10}$/, // exactly 10 digits
                message: "Mobile number must be exactly 10 digits",
              },
            }}
            render={({ field }) => (
              <Form.Group className="mb-3" controlId="mobile_number">
                <Form.Label>Mobile Number*</Form.Label>
                <Form.Control
                  {...field}
                  inputMode="numeric"
                  maxLength={10}
                  isInvalid={!!errors.mobileNumber}
                />
              </Form.Group>
            )}
          />

          <Controller
            name="roles"
            control={control}
            rules={{ required: "Please select at least one role" }}
            render={({ field }) => {
              const options = roleOptions.map((r) => ({
                value: String(r.id),
                label: r.name,
              }));
              const value = (field.value || [])
                .map((id) => options.find((o) => o.value === String(id)))
                .filter(Boolean);
              return (
                <Form.Group className="mb-3" controlId="roles">
                  <Form.Label>Roles*</Form.Label>
                  <Select
                    isMulti
                    isLoading={rolesLoading}
                    options={options}
                    value={value}
                    onChange={(items) =>
                      field.onChange((items || []).map((i) => i.value))
                    }
                    classNamePrefix="react-select"
                    placeholder="Select roles..."
                  />
                  {errors.roles && (
                    <div className="invalid-feedback d-block">
                      {errors.roles.message}
                    </div>
                  )}
                </Form.Group>
              );
            }}
          />

          {!isEdit && (
            <Controller
              name="password"
              control={control}
              rules={{ required: "Password is required" }}
              render={({ field }) => (
                <Form.Group className="mb-3" controlId="password">
                  <Form.Label>Password*</Form.Label>
                  <Form.Control
                    type="password"
                    {...field}
                    isInvalid={!!errors.password}
                    autoComplete="new-password" // 👈 tells browser this is for creating a new pass
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.password?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              )}
            />
          )}

          <Controller
            name="isActive"
            control={control}
            render={({ field }) => (
              <Form.Group className="mb-3" controlId="status">
                <Form.Label>Status*</Form.Label>
                <Form.Select {...field}>
                  <option value={true}>Active</option>
                  <option value={false}>Inactive</option>
                </Form.Select>
              </Form.Group>
            )}
          />

          <Alert variant="info">
            Please ensure your Excel file has columns: Name, Email, Password,
            Mobile Number
          </Alert>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Cancel
          </Button>
          <Button variant="primary" type="submit">
            {isEdit ? "Update" : "Create"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default EditUserModal;
